import type { ComponentProps } from 'react'
import { classNames } from '~/utils/client/helpers'
import { FadeInStagger, FadeInWithOffset } from '../ui/FadeIn'
import type { motion } from 'framer-motion'

export const SubPageInnerContainer = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof motion.div>) => {
  return (
    <FadeInWithOffset className={classNames('px-4 pt-6 sm:px-0 sm:pt-0', className)} {...props}>
      {children}
    </FadeInWithOffset>
  )
}

export const SubPageWrapper = ({ className, children, ...props }: ComponentProps<'main'>) => {
  return (
    <main className={classNames('sm:py-6 bg-white sm:bg-surface', className)} {...props}>
      <FadeInStagger duration="fastest">{children}</FadeInStagger>
    </main>
  )
}
